'use client'

import { toContactPage } from '@/feature/contact/service/contact.routing'
import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { Icon } from '@/ui/icons/icon/Icon'
import {
  DEFAULT_PHONE_CALLBACK_IMAGE_URL,
  NeedHelpBanner,
} from '@/ui/need-help-banner/NeedHelpBanner.client'

type CMSNeedHelpBannerProps = WithPayloadBlockId & {
  className?: string
}

export function CMSNeedHelpBanner({
  className,
  'data-payload-block-id': dataPayloadBlockId,
}: CMSNeedHelpBannerProps): React.ReactElement {
  const { t, Trans } = useTranslation(['phoneCallbackBanner'])

  return (
    <NeedHelpBanner
      className={className}
      data-payload-block-id={dataPayloadBlockId}
      imageUrl={DEFAULT_PHONE_CALLBACK_IMAGE_URL}
      imageAlt={t('phoneCallbackBanner:imageAlt')}
      title={<Trans i18nKey="phoneCallbackBanner:title" components={{ bold: <b /> }} />}
      linkText={t('phoneCallbackBanner:buttonText')}
      href={toContactPage}
      icon={<Icon.Phone />}
    />
  )
}
